import PropTypes from 'prop-types';
import React from 'react';
import StyledButton from './button.style';
import { LongArrowRight, ArrowRight } from '../../icons/arrow/arrow';

const Button = React.forwardRef((props, ref) => {
  const {
    children,
    type = 'button',
    disabled = false,
    arrowLeft = false,
    noBorder = false
  } = props;

  return (
    <StyledButton
      ref={ref}
      type={type}
      disabled={disabled}
      noBorder={noBorder}
      arrowLeft={arrowLeft}
      {...props}
    >
      <span className="button__arrowLong">
        <LongArrowRight aria-hidden="true" />
      </span>
      <span className="button__arrow">
        <ArrowRight aria-hidden="true" />
      </span>

      {children}
    </StyledButton>
  );
});

Button.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  arrowLeft: PropTypes.bool,
  noBorder: PropTypes.bool,
  type: PropTypes.oneOf(['submit', 'button', 'reset'])
};

export default Button;
